import React, { useCallback } from 'react';
import { ToggleButtonGroup, ToggleButton, Tooltip } from '@mui/material';
import TextFieldsIcon from '@mui/icons-material/TextFields';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import Filter1Icon from '@mui/icons-material/Filter1';
import ShowChartIcon from '@mui/icons-material/ShowChart';

import {
  useTableDispatch,
  useTableState,
} from '../../../context/TableSchemaBuilderContext';
import { DATA_TYPES } from './Fields/Fields';
import GroupWrapper from '../Wrappers/GroupWrapper';

const CellDataTypeGroup = () => {
  const { ui, schema } = useTableState();
  const dispatch = useTableDispatch();

  const handleDataTypeChange = useCallback(
    (_event, newType) => {
      if (!newType || !ui.currentCell) {
        return;
      }

      dispatch({
        type: 'UPDATE_CELL_DATA_TYPE',
        payload: {
          cellId: ui?.currentCell,
          dataType: newType,
        },
      });
    },
    [dispatch, ui?.currentCell]
  );

  const currentDataType =
    schema?.cells?.[ui.currentCell]?.dataType || DATA_TYPES.TEXT;

  return (
    <GroupWrapper label="Data Type">
      <ToggleButtonGroup
        size="small"
        exclusive
        value={currentDataType}
        onChange={handleDataTypeChange}
        sx={{ mx: 1 }}
      >
        <Tooltip title="Text">
          <ToggleButton value={DATA_TYPES.TEXT}>
            <TextFieldsIcon fontSize="small" />
          </ToggleButton>
        </Tooltip>
        <Tooltip title="Date">
          <ToggleButton value={DATA_TYPES.DATE}>
            <CalendarTodayIcon fontSize="small" />
          </ToggleButton>
        </Tooltip>
        <Tooltip title="Integer">
          <ToggleButton value={DATA_TYPES.INTEGER}>
            <Filter1Icon fontSize="small" />
          </ToggleButton>
        </Tooltip>
        <Tooltip title="Float">
          <ToggleButton value={DATA_TYPES.FLOAT}>
            <ShowChartIcon fontSize="small" />
          </ToggleButton>
        </Tooltip>
      </ToggleButtonGroup>
    </GroupWrapper>
  );
};

export default CellDataTypeGroup;
